import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M13.742 3.958v2.084H6.659V3.958h7.083Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12.908 6.042v2.5l1.098.96c.362.316.57.774.57 1.254v3.619c0 .92-.747 1.667-1.668 1.667H7.504c-.92 0-1.666-.747-1.666-1.667v-3.623c0-.478.205-.933.564-1.25l1.09-.96v-2.5h5.416Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M6.034 13.542h5.208v-2.917H6.034" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);